import React from 'react'
import * as Badges from '../../../../../../components/badges'
import ExpandButton from '../expandButton'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import DeliveryHoursTable from './deliveryHoursTable'
import PropTypes from "prop-types"

class DeliveryHoursUpdated extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false }

    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }))
  }

  render() {
    let tables = []
    let payload = JSON.parse(this.props.item.payload)
        
    if (payload.From.length > 0) {
      tables.push(<React.Fragment key={'from'}><div><h4>From</h4><DeliveryHoursTable data={payload.From} /></div></React.Fragment>)
    }
        
    if (payload.To.length > 0) {
      tables.push(<React.Fragment key={'to'}><div><h4>To</h4><DeliveryHoursTable data={payload.To} /></div></React.Fragment>)
    }
                
    return <tr>
      <td>
        <Badges.DeliveryHoursUpdated /><ExpandButton isExpanded={this.state.isExpanded} onClick={this.toggleExpand} />
      </td>
      <td>
        {!this.state.isExpanded && <span>Delivery Hours Updated</span>}
        {this.state.isExpanded && tables}
      </td>
      <td>{FormatUtcDateAsLocal(this.props.item.createdUtc)}</td>
      <td>{this.props.item.createdBy}</td>
    </tr>
  }
}

DeliveryHoursUpdated.propTypes = {
  item: PropTypes.shape({
    payload: PropTypes.string.isRequired,
    createdUtc: PropTypes.string,
    createdBy: PropTypes.string
  }).isRequired
}

export default DeliveryHoursUpdated



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/deliveryHoursUpdated/index.js